module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.icon && _vm.icon.startsWith('#')) ? _c('svg', {
    staticClass: "icon icon-item",
    style: (_vm.iconStyle),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.nClick
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.icon
    }
  })]) : (_vm.icon && _vm.icon.startsWith('el-icon')) ? _c('i', {
    class: [_vm.icon],
    on: {
      "click": _vm.nClick
    }
  }) : _c('img', {
    style: (_vm.iconStyle),
    attrs: {
      "src": _vm.icon
    },
    on: {
      "click": _vm.nClick
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-38f2f680","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ni-ui/icon/icon.vue
// module id = R1aR
// module chunks = 81